import { Controller } from "@hotwired/stimulus";

const inactiveClasses = ["opacity-50", "cursor-not-allowed"];

export default class extends Controller {
  static targets = ["input", "preview", "form", "defaultIcon", "submitButton"];

  connect() {
    console.log("Avatar upload controller connected");
    console.log("Has form target:", this.hasFormTarget);
    console.log("Has input target:", this.hasInputTarget);
    console.log("Form target:", this.formTarget);
    console.log("Input target:", this.inputTarget);

    this.#updateSubmitButton(false);
  }

  #updateSubmitButton(enabled) {
    for (const klass of inactiveClasses) {
      this.submitButtonTarget.classList.toggle(klass, !enabled);
      this.submitButtonTarget.disabled = !enabled;
    }
  }

  selectFile(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  preview() {
    const file = this.inputTarget.files[0];
    if (file) {
      // Hide the default icon if it exists
      if (this.hasDefaultIconTarget) {
        this.defaultIconTarget.classList.add("hidden");
      }

      // Create or update the preview image
      if (!this.hasPreviewTarget) {
        // Create a new image element if it doesn't exist
        const img = document.createElement("img");
        img.classList.add("h-full", "w-full", "object-cover");
        img.dataset.avatarUploadTarget = "preview";
        this.inputTarget.parentElement.appendChild(img);
      }

      // Update the preview image with the selected file
      const reader = new FileReader();
      reader.onload = e => {
        this.previewTarget.src = e.target.result;
        this.previewTarget.classList.remove("hidden");
      };
      reader.readAsDataURL(file);

      // Auto-submit the form if needed
      // Uncomment this if you want the form to submit immediately after selecting a file
      // this.submitForm()

      this.#updateSubmitButton(true);
    }
  }

  submitForm(event) {
    if (event) event.preventDefault();

    // Only submit if a file has been selected
    if (this.inputTarget.files.length > 0) {
      this.formTarget.submit();
      this.#updateSubmitButton(false);
    } else {
      console.warn("No file selected for upload");
    }
  }
}
